'use strict';

var util = require('../../util/property-util');

module.exports = {
    trains: /*@ngInject*/  ["TrainService", "$stateParams", function (TrainService, $stateParams) {
        if (util.isDefined($stateParams.projectId)) {
            return TrainService.getTrains().query({
                "projectId": $stateParams.projectId
            }).$promise;
        }
    }],
    words: /*@ngInject*/  ["ReferenceAreaService", "AdvancedQueryResourceService", "$q", "$stateParams", function (ReferenceAreaService, AdvancedQueryResourceService, $q, $stateParams) {
        var words = {
            ids: [],
            values: [],
            mathOperators: [],
            operators: [],
            valids: new Map()
        };
        var deferred = $q.defer();

        // stations
        var promise1 = ReferenceAreaService.waypoints().query({projectId: $stateParams.projectId}).$promise.then(function (data) {
            var stations = [];
            data.forEach(function (entry) {
                if (util.isDefined(entry.abbreviation)) {
                    if (words.values.indexOf(entry.abbreviation) == -1) {
                        words.values.push(entry.abbreviation);
                        stations.push(entry.abbreviation);
                    }
                }
            });

            words.valids.set("START_STATION", stations);
            words.valids.set("END_STATION", stations);
        });

        // days
        var days = [];
        days.push("MONDAY");
        days.push("TUESDAY");
        days.push("WEDNESDAY");
        days.push("THURSDAY");
        days.push("FRIDAY");
        days.push("SATURDAY");
        days.push("SUNDAY");

        days.forEach(function (day) {
            words.values.push(day);
        });
        words.valids.set("DAY", days);

        // default keywords
        words.ids.push("SERVICE_ID");
        words.ids.push("START_STATION");
        words.ids.push("END_STATION");
        words.ids.push("DAY");
        words.ids.push("DEPARTURE_TIME");
        words.ids.push("ARRIVAL_TIME");

        // project specific keywords
        var promise3 = AdvancedQueryResourceService.SQIs().query({projectId: $stateParams.projectId}).$promise.then(function (data) {
             data.forEach(function (entry) {
                var title = entry.title.toUpperCase();
                title = title.replaceAll(" ", "_");
                if (words.ids.indexOf(title) == -1) {
                    words.ids.push(title);
                }
            });
        });

        words.mathOperators.push("==");
        words.mathOperators.push("=");
        words.mathOperators.push(">=");
        words.mathOperators.push("<=");
        words.mathOperators.push("!=");
        words.mathOperators.push(">");
        words.mathOperators.push("<");

        words.operators.push("AND");
        words.operators.push("OR");

        $q.all([promise1, promise3]).then(function () {
            deferred.resolve(words);
        });
        return deferred.promise;
    }]
};